export const getSVGParts = (options) => {
    let partOptions = []
    options.forEach((option) => {
        if (option && option.id && option.surfaceType == 'surface') {
            partOptions.push({
                text: option.name,
                callback: () => option.productPartId,
                value: option,
            })
        }
    })
    return partOptions
}
export const getDesignProjectItemProcessesAndLiner = (currentStructure) => {
    let processes = {}
    let linerObject = null
    if (currentStructure && currentStructure.elements) {
        for (let e = 0; e < currentStructure.elements.length; e++) {
            let obj = currentStructure.elements[e]

            // skipped - removed, not added elements from processes count
            let isOptional = obj.isOptional ? '' + obj.isOptional : null
            let isOptionalAdded = obj.isOptionalAdded ? '' + obj.isOptionalAdded : null

            if (isOptional && isOptional == 'true') {
                if (!(isOptionalAdded && isOptionalAdded == 'true')) {
                    continue
                }
            }
            if (obj.removed && obj.removed == true) continue

            if (obj.type == 'liner') {
                linerObject = obj.value
            }
            if (obj && obj.print && obj.print.name !== 'Digital') {
                if (!processes[obj.print.name]) {
                    processes[obj.print.name] = {}
                    processes[obj.print.name].colors = []
                    if (obj.color && obj.color.colorHex) {
                        processes[obj.print.name].colors.push(obj.color.colorHex)
                        processes[obj.print.name].passes = 1
                    }
                } else {
                    if (
                        obj.color.colorHex &&
                        !processes[obj.print.name].colors.includes(obj.color.colorHex)
                    ) {
                        processes[obj.print.name].passes += 1
                        processes[obj.print.name].colors.push(obj.color.colorHex)
                    }
                }
            } else {
                if (obj.print && obj.print.name == 'Digital') {
                    processes[obj.print.name] = {}
                    processes[obj.print.name].colors = []
                    if (obj.color && obj.color.colorHex)
                        processes[obj.print.name].colors.push(obj.color.colorHex)
                    processes[obj.print.name].passes = 1
                }
            }
        }
    }
    return { processes, linerObject }
}

export const getAlignmentOptions = (options) => {
    let alignmentOptions = []
    options.forEach((option) => {
        alignmentOptions.push({
            text: option,
            callback: () => option,
        })
    })
    return alignmentOptions
}
export const getFontSizeOptions = ({ fontMin, fontMax }) => {
    let fontSizeOptions = []

    for (let i = fontMin; i <= fontMax; i++) {
        fontSizeOptions.push({
            text: i + 'pt',
            callback: () => i + 'pt',
            value: i,
        })
    }

    return fontSizeOptions
}

export const getPrintOptions = (options) => {
    let printOptions = []

    options.forEach((option) => {
        printOptions.push({
            text: option,
            callback: () => option,
        })
    })
    return printOptions
}
export const getPaperOptions = (options) => {
    let paperOptions = []

    options.forEach((option) => {
        paperOptions.push({
            text: option.name,
            weight: option.weight,
            texture: option.texture,
            img: option.url,
            description: option.description,
            brand: option.brand,
            color: option.color,
            colorHex: option.colorHex,
        })
    })
    return paperOptions
}
export const getPaperSurfaceOptions = (paperObject) => {
    let paperSurfaces = []
    let surface = null
    for (let s = 0; s < surfaceIds.length; s++) {
        if (paperObject.alternateSurfaceId == surfaceIds[s].id) {
            paperSurfaces.push({
                name: surfaceIds[s].name,
                id: surfaceIds[s].id,
                url: paperObject.alternateUrl,
            })
        }
        if (paperObject.surfaceId == surfaceIds[s].id) {
            surface = {
                name: surfaceIds[s].name,
                id: surfaceIds[s].id,
                url: paperObject.url,
            }
            paperSurfaces.push(surface)
        }
    }
    return { surfaceOptions: paperSurfaces, surface }
}

export const commonValidationRules = {
    requiredRules: [(v) => !!v || 'This field is required'],
    minLengthTenChars: [
        (v) => !!v || 'This field is required',
        (v) => (v && v.length >= 10) || 'This field must be at least 10 characters',
    ],
    emailIdRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    passwordRule: [
        (v) => !!v || 'Password is required',
        (v) =>
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/.test(v) ||
            'Password must contain atleast one lowercase, one uppercase, one digit and one special character',
    ],
}
export const getCurrentDate = () => {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
}
export const isoStringToYMD = (date) => {
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let dt = newDate.getDate()
    let hr = newDate.getHours()
    let minutes = newDate.getMinutes()

    if (dt < 10) {
        dt = '0' + dt
    }
    if (month < 10) {
        month = '0' + month
    }
    if (hr < 10) {
        hr = '0' + hr
    }
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    return year + '-' + month + '-' + dt + ' ' + hr + ':' + minutes
}
export const getCurrentYMDDate = () => {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [day, month, year].join('/')
}
export const isoStringToNormalDate = function () {
    let tmp = new Date().toISOString().split('T')[0]
    tmp = tmp.split('-')
    return tmp[0] + '-' + tmp[1] + '-' + tmp[2]
}

export const doGetImageBuffer = async (url) => {
    return fetch(url).then((res) => res.buffer())
}

export const processDetails = [
    { name: 'Thermography', processID: 1, shortName: 'T' },
    { name: 'Engraving', processID: 2, shortName: 'E' },
    { name: 'Letterpress', processID: 5, shortName: 'L' },
    { name: 'Digital', processID: 21, shortName: 'G' },
    { name: 'Embossing', processID: 6, shortName: 'B' },
    { name: 'Flat', processID: 7, shortName: 'F' },
    { name: 'Flat Print', processID: 7, shortName: 'F' },
    { name: 'Foil', processID: 15, shortName: 'R' },
]

export const processors = {
    Thermography: 1,
    Engraving: 2,
    Letterpress: 5,
    Digital: 21,
    Embossing: 6,
    'Flat Print': 7,
    Flat: 7,
    Foil: 15,
}

export const SublineTypeIds = {
    text: 14,
    motif: 14,
    monogram: 14,
    liner: 8,
    image: 14,
    clipart: 14,
}
export const surfaceIds = [
    { name: 'Front', id: 1 },
    { name: 'Back', id: 2 },
    { name: 'Face', id: 3 },
    { name: 'Flap', id: 4 },
    { name: 'Inside', id: 5 },
    { name: 'Outside', id: 6 },
    { name: 'Bottom Back', id: 7 },
]

// Define the display order for surfaces in the stepper/carousel
// This should match the logical flow of the product design
export const SURFACE_DISPLAY_ORDER = [
    'Outside', // Alternate surface (surfaceType: 'alternateSurface')
    'Inside', // Main surface (surfaceId: 5)
    'Front', // Main surface (surfaceId: 1)
    'Back', // Main surface (surfaceId: 2)
    'Face', // Main surface (surfaceId: 3)
    'Flap', // Main surface (surfaceId: 4)
    'Bottom Back', // Main surface (surfaceId: 7)
    'Liner', // Special case for liner
]

/**
 * Get surface name from surfaceId and surfaceType
 * @param {number} surfaceId - The surface ID
 * @param {string} surfaceType - The surface type ('surface' or 'alternateSurface')
 * @returns {string} The surface name
 */
export const getSurfaceName = (surfaceId, surfaceType) => {
    // Handle alternate surface (always "Outside")
    if (surfaceType === 'alternateSurface') {
        return 'Outside'
    }

    // Handle regular surfaces using surfaceIds lookup
    if (surfaceType === 'surface' && surfaceId) {
        const surface = surfaceIds.find((s) => s.id === surfaceId)
        return surface?.name || 'Unknown'
    }

    return 'Unknown'
}

/**
 * Get the display order index for a surface name
 * @param {string} surfaceName - The surface name
 * @returns {number} The display order index (-1 if not found)
 */
export const getSurfaceDisplayOrder = (surfaceName) => {
    return SURFACE_DISPLAY_ORDER.indexOf(surfaceName)
}

export const priceFormatter = (price) => {
    if (price == null || isNaN(price)) return '0.00'

    // Multiply by 100, round to nearest integer, then divide by 100
    return (Math.round(Number(price) * 100) / 100).toFixed(2)
}

export const altCharCodes = [
    { char: 'A', altCode: '\u00CC' },
    { char: 'B', altCode: '\u00CD' },
    { char: 'C', altCode: '\u02D8' },
    { char: 'D', altCode: '\u00CF' },
    { char: 'E', altCode: '\u00D0' },
    { char: 'F', altCode: '\u00D1' },
    { char: 'G', altCode: '\u00D2' },
    { char: 'H', altCode: '\u00D3' },
    { char: 'I', altCode: '\u00D4' },
    { char: 'J', altCode: '\u00D5' },
    { char: 'K', altCode: '\u00D6' },
    { char: 'L', altCode: '\u0152' },
    { char: 'M', altCode: '\u00D8' },
    { char: 'N', altCode: '\u00D9' },
    { char: 'O', altCode: '\u00DA' },
    { char: 'P', altCode: '\u00DB' },
    { char: 'Q', altCode: '\u00DC' },
    { char: 'R', altCode: '\u00DD' },
    { char: 'S', altCode: '\u00DE' },
    { char: 'T', altCode: '\u00DF' },
    { char: 'U', altCode: '\u00E0' },
    { char: 'V', altCode: '\u00E1' },
    { char: 'W', altCode: '\u00E2' },
    { char: 'X', altCode: '\u00E3' },
    { char: 'Y', altCode: '\u00E4' },
    { char: 'Z', altCode: '\u00E5' },
]

/// snake case to hump and hump to snake
const toCase = (stringToCaseFn) => (value) => {
    const convertFn = toCase(stringToCaseFn)
    if (value === null) {
        return null
    } else if (typeof value === 'string') {
        return stringToCaseFn(value)
    } else if (value && value.length !== undefined) {
        return value.map(convertFn)
    } else if (typeof value === 'object') {
        const object = {}
        Object.keys(value).forEach((key) => {
            let _value = value[key]
            if (_value && typeof _value === 'object' && !checkForArray(value[key])) {
                _value = convertFn(value[key])
            }
            object[convertFn(key)] = _value
        })
        return object
    } else {
        return value
    }
}

const snakeStringToCamel = (str) =>
    str.replace(/ /g, '_').replace(/_(\w)/g, (m) => m[1].toUpperCase())
export const snakeToCamel = toCase(snakeStringToCamel)

const camelStringToSnake = (str) => str.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`)
export const camelToSnake = toCase(camelStringToSnake)

function checkForArray(variable) {
    if (Array.isArray(variable)) {
        if (variable.length === 0) {
            return false
        } else {
            for (let i = 0; i < variable.length; i++) {
                if (
                    typeof variable[i] === 'object' ||
                    variable[i] === null ||
                    Array.isArray(variable[i])
                ) {
                    return false
                }
            }
            return true
        }
    } else {
        return false
    }
}

export function getDomain(hostname) {
    const parts = hostname.split('.')
    if (parts.length >= 2) {
        return '.' + parts.slice(-2).join('.')
    }
    return hostname
}

// getCurrentItemDeltaStructure removed: unused (no callers), was the only consumer of pricing.service.js's crane-pricer wrapper

export const getErrorMessage = (error) => {
    let errorMessage = 'An unexpected error occurred.'

    if (typeof error === 'string') {
        // If a string was thrown
        errorMessage = error
    } else if (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof error.message === 'string'
    ) {
        // If it's an object with a message property
        errorMessage = error.message
    }

    return errorMessage
}

// export  const getDomain = (domain) => {
//         if (domain) {
//             const s = domain.split('.')
//             if (s.length < 3) {
//                 return domain
//             }
//             return s.slice(1).join('.')
//         }
//     }

export const sumItem = ({ quantity, ...a }, b) => ({
    quantity,
    ...Object.keys(a).reduce(
        (r, k) => ({ ...r, [k]: priceFormatter(Number(a[k]) + Number(b[k])) }),
        {}
    ),
})

export const sumOfTwoPartsQtyPrices = (...arrs) => [
    ...[]
        .concat(...arrs) // combine the arrays
        .reduce(
            (
                m,
                o // reduce the combined arrays to a Map
            ) =>
                m.set(
                    o.quantity, // if add the item to the Map
                    m.has(o.quantity) ? sumItem(m.get(o.quantity), o) : { ...o } // if the item exists in Map, sum the current item with the one in the Map. If not, add a clone of the current item to the Map
                ),
            new Map()
        )
        .values(),
]
// used in adjusted formula to check for valid print method.
// Written as object, to replace in element print
const mainPrintsObject = [
    { name: 'Thermography', processId: 1, shortName: 'T' },
    { name: 'Engraving', processId: 2, shortName: 'E' },
    { name: 'Letterpress', processId: 5, shortName: 'L' },
    { name: 'Digital', processId: 21, shortName: 'G' },
]

export const getRoundedUpFinalPrice = ({ qty, price }) => {
    let twoDigitsRoundUp = priceFormatter(price) / qty
    twoDigitsRoundUp = priceFormatter(twoDigitsRoundUp)
    return priceFormatter(twoDigitsRoundUp * qty)
}

export const ensurePrintableElements = ({ elements = [] }) => {
    let printableElements = getAllPrintableElements({ elements })

    if (printableElements.length > 0) {
        return printableElements
    }

    const firstWithPrint = elements.find((el) => el?.print != null)
    if (!firstWithPrint) {
        return []
    }
}
export const getCombinedElementsFromAllParts = ({ baseStructures }) => {
    const combinedElements = (baseStructures || []).flatMap((item) => {
        const primaryElements = Array.isArray(item?.elements) ? snakeToCamel(item?.elements) : []

        return primaryElements
    })
    return combinedElements
}
export const getAllPrintableElements = ({ elements }) => {
    const combinedElements = snakeToCamel(elements)
    let primaryElements = []
    for (let e = 0; e < combinedElements.length; e++) {
        const currentEle = combinedElements[e]

        if (currentEle.type == 'liner' || currentEle.type == 'paper') continue

        if (currentEle.removed && currentEle.removed == true) continue

        primaryElements.push(currentEle)
    }
    return primaryElements
}
export const getFirstColorElement = ({ elements = [] }) => elements.find((el) => Boolean(el?.color))
/**
 * Aggregates print usage from elements.
 *
 * For each main print:
 * - Counts how many elements use that print
 * - Tracks unique real colors per print
 * - Ignores null / undefined colors for color count
 */
const getMainPrintUsage = ({ elements = [] }) => {
    const allowedPrints = new Set(mainPrintsObject.map((p) => p.name.toLowerCase()))
    const result = {}
    for (const el of elements) {
        const printName = el?.print?.name?.toLowerCase()
        if (!printName || !allowedPrints.has(printName)) continue

        // Normalize color:
        // - real color → lowercase
        // - null / undefined → "no-color"
        const colorKey = el?.color?.name ? el.color.name.toLowerCase() : null

        // Initialize print entry if missing
        if (!result[printName]) {
            result[printName] = {
                print: el.print,
                elementCount: 0,
                uniqueColorKeys: new Set(),
            }
        }

        // Count elements using this print
        result[printName].elementCount += 1

        // ✅ Track color ONLY if it exists
        if (colorKey) {
            result[printName].uniqueColorKeys.add(colorKey)
        }
    }

    // Convert color Set → count for easier downstream usage
    Object.values(result).forEach((entry) => {
        entry.uniqueColorCount = entry.uniqueColorKeys.size
        delete entry.uniqueColorKeys
    })
    return result
}

/**
 * Calculates a weighted average multiplier.
 *
 * Each print's multiplier is weighted by how many elements use it.
 *
 * Example:
 * - 2 elements @ 1.5
 * - 1 element @ 1.4
 * → average = (2*1.5 + 1*1.4) / 3
 */
const getWeightedAverageMultiplier = ({ uniquePrintWithCount = {}, printPricingMap }) => {
    let total = 0
    let count = 0

    for (const [printKey, { elementCount }] of Object.entries(uniquePrintWithCount)) {
        const multiplier = printPricingMap?.[printKey]?.multiplier
        if (!multiplier || !elementCount) continue

        total += multiplier
        count = count + 1
    }

    return count ? total / count : 0
}

/**
 * Calculates total color flat-rate add-ons.
 *
 * Rules:
 * - Flat-rate applies ONLY if a print has more than one unique color
 * - Null / undefined color counts as a single color
 */
const calculatePrintColorAddonTotal = ({ uniquePrintWithCount = {}, printPricingMap = {} }) => {
    let total = 0

    const maxColorAddon = Math.max(
        ...Object.keys(uniquePrintWithCount).map(
            (printKey) => Number(printPricingMap[printKey]?.colorAddon) || 0
        )
    )

    for (const [printKey, stats] of Object.entries(uniquePrintWithCount)) {
        const pricing = printPricingMap[printKey]
        if (!pricing) continue

        const colorCount = Number(stats.uniqueColorCount) || 0
        const colorAddon = Number(pricing.colorAddon) || 0

        if (colorAddon === maxColorAddon) {
            // Max addon → charge only for extra colors
            if (colorCount > 1) {
                total += (colorCount - 1) * colorAddon
            }
        } else {
            // Other addons → charge for all colors
            if (colorCount >= 1) {
                total += colorCount * colorAddon
            }
        }
    }
    return total
}

/**
 * Final price calculator.
 *
 * Formula:
 *   finalPrice =
 *     (basePrice × weightedAverageMultiplier)
 *     + totalColorAddons
 */
export const getFinalPrice = ({ elements, basePrice, printPricingMap }) => {
    // Aggregate print usage & color stats
    const uniquePrintWithCount = getMainPrintUsage({ elements })
    let avgMultiplier = printPricingMap?.['thermography']?.multiplier // default multiplier
    // Compute weighted process multiplier
    if (uniquePrintWithCount && Object.keys(uniquePrintWithCount).length > 0) {
        // Compute weighted process multiplier
        avgMultiplier = getWeightedAverageMultiplier({
            uniquePrintWithCount,
            printPricingMap,
        })
    }

    // Compute color flat-rate add-ons
    const addonPrice = calculatePrintColorAddonTotal({
        uniquePrintWithCount,
        printPricingMap,
    })

    // Final calculated price
    const finalPrice = basePrice * avgMultiplier + addonPrice
    return finalPrice //  { price: finalPrice, addonPrice: addonPrice };
}
